'use client';

import { useInView } from '@/hooks/useInView';

import styles from './LocationPin.module.css';

type LocationPinWiggleProps = {
  children: React.ReactNode;
};

/**
 * Runs the shared pin wiggle only while the settled pin is on screen. The
 * entrance spring and section-level GSAP reveals remain on outer elements, so
 * their transforms never compete with this loop.
 */
export function LocationPinWiggle({ children }: LocationPinWiggleProps) {
  const { ref, inView } = useInView<HTMLSpanElement>({
    once: false,
    threshold: 0.25,
  });

  return (
    <span
      ref={ref}
      className={[styles.bounce, inView ? styles.wiggle : null]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </span>
  );
}
